import './init';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import * as Sentry from '@sentry/react';
import * as TYPES from '~/common/redux/types';
import App from './App';
import rootReducer from './common/redux/reducers';
import rootSagas from './common/redux/sagas';
import translationMappings from './locales';
import { ENVIRONMENT } from './common/utils/constants';

const renderApp = (externalContainer, baseRoute, externalProps) => {
  const initialReduxState = {
    root: {},
    ...(externalProps ? externalProps.initial_redux_state : {}),
  };

  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    preloadedState: initialReduxState,
    reducer: {
      root: rootReducer,
      Data: (state = {}) => state,
    },
    middleware: (getDefaultMiddleware) => {
      const customizedMiddleware = getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: Object.keys(TYPES),
          ignoredPaths: ['payload.onSuccess', 'payload.onError'],
        },
      });

      const middleware = [...customizedMiddleware, sagaMiddleware];

      if (process.env.NODE_ENV === ENVIRONMENT.DEVELOPMENT) {
        // eslint-disable-next-line global-require
        const { logger } = require(`redux-logger`);
        middleware.push(logger);
      }

      return middleware;
    },
  });
  sagaMiddleware.run(rootSagas);

  const props = {
    baseRoute,
    store,
    ttp: translationMappings(initialReduxState.Data.locale),
  };

  const { sentryDSN, sentryEnv } = externalProps.props;
  if (sentryDSN && sentryEnv && sentryEnv !== ENVIRONMENT.LOCAL) {
    Sentry.init({
      dsn: sentryDSN,
      environment: sentryEnv,
      release: process.env.REACT_APP_COMMIT_ID,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 0.1,
      tracePropagationTargets: ['localhost', /^https:\/\/(.*\.)?tesla\.com\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      initialScope: { tags: { app: 'teslaaccount' } },
    });
  }

  ReactDOM.render(<App {...props} />, externalContainer);
};

export default renderApp;
